import { takeLatest, put } from 'redux-saga/effects';

import { Actions as ResponsesGetAllActions } from 'app/redux/responses/get-all/actions';
import { Types } from './actions';

const initialize = function*() {
  yield put(ResponsesGetAllActions.request());
};

const ResultsSaga = function*() {
  yield takeLatest(Types.INITIALIZE, initialize);
};

export default ResultsSaga;



// WEBPACK FOOTER //
// ./src/redux/ui/results/sagas.js